import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { TabMenu } from 'primereact/tabmenu';
import { DataForType } from '../DataForType';
import { AppSelectField, AppNumberField } from '../../../../../../Components/FormKit';

const cardHeader = (title) => (
    <div style={{
        background: '#f8fafc',
        padding: '0.65rem 1rem',
        borderBottom: '1px solid #e2e8f0',
        borderRadius: '14px 14px 0 0',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
    }}>
        <span style={{ fontWeight: 700, fontSize: '0.72rem', color: '#1565C0', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>
            {title}
        </span>
        <div style={{ flex: 1, height: '1px', background: '#bfdbfe' }} />
    </div>
);

export const StepVisitDetails = ({
    currentStatus,
    handleStatusChange,
    statusOptions,
    isReadOnly,
    isPM,
    selectedVisitTypes,
    visitTypeOptions,
    handleVisitTypeChange,
    visitsData,
    updateVisitData,
    validationErrors,
    completionOutcome,
    onCompletionOutcomeChange
}) => {
    const [activeTab, setActiveTab] = React.useState(0);

    React.useEffect(() => {
        if (activeTab >= selectedVisitTypes.length && selectedVisitTypes.length > 0) {
            setActiveTab(selectedVisitTypes.length - 1);
        }
    }, [selectedVisitTypes.length, activeTab]);

    // hasDateMismatch removed — tentativeDate field eliminated (MANUS coordinates date)
    // const hasDateMismatch = ...

    const items = selectedVisitTypes.map((type) => {
        const hasError = validationErrors?.[type] && Object.keys(validationErrors[type]).length > 0;
        return {
            label: type,
            icon: hasError ? 'pi pi-exclamation-circle text-red-500' : null,
            className: hasError ? 'p-error-tab' : ''
        };
    });

    return (
        <div className="fk-root flex flex-column gap-3">

            {/* Card: Estado + Visits (PF) + Resultado en la misma fila */}
            <div className="tk-table-card">
                {cardHeader('Estado de la Visita')}
                <div style={{ padding: '1rem' }}>
                    <div className="grid align-items-start">
                        {/* Status dropdown */}
                        <div className={
                            currentStatus === 'completed'
                                ? (isPM ? 'col-12 md:col-5' : 'col-12 md:col-5')
                                : (isPM ? 'col-12' : 'col-12 md:col-8')
                        }>
                            <AppSelectField
                                label="Estatus"
                                value={currentStatus}
                                options={statusOptions}
                                onChange={handleStatusChange}
                                placeholder="Selecciona el estado"
                                disabled={isReadOnly}
                                helperText={
                                    currentStatus === 'scheduled' ? "Se enviará correo de 'Visita Programada'." :
                                    currentStatus === 'postponed' ? "Se enviará correo de 'Visita Reprogramada'." :
                                    currentStatus === 'paused' ? "Se enviará correo de 'Visita Pausada'." :
                                    currentStatus === 'completed' && !completionOutcome ? "Selecciona el resultado de la visita." :
                                    currentStatus === 'completed' && completionOutcome === 'successful' ? "Se enviará correo de éxito y se avanzará al siguiente paso." :
                                    currentStatus === 'completed' && completionOutcome === 'unsuccessful' ? "Se enviará correo indicando que la visita no fue aprobada." :
                                    undefined
                                }
                            />
                        </div>

                        {/* No. de Visitas (solo PF, oculto cuando completed para dar espacio al Resultado) */}
                        {!isPM && currentStatus !== 'completed' && (
                            <div className="col-12 md:col-4">
                                <AppNumberField
                                    label="No. de Visitas"
                                    value={visitsData['Visita Particular']?.visitsCount ?? 2}
                                    onValueChange={(e) => updateVisitData('Visita Particular', 'visitsCount', e.value)}
                                    min={1}
                                    disabled={isReadOnly || currentStatus === 'paused'}
                                    showButtons
                                    buttonLayout="horizontal"
                                    step={1}
                                    incrementButtonClassName="p-button-text p-button-success"
                                    decrementButtonClassName="p-button-text p-button-danger"
                                    incrementButtonIcon="pi pi-plus"
                                    decrementButtonIcon="pi pi-minus"
                                />
                            </div>
                        )}

                        {/* Resultado — botones editables */}
                        {currentStatus === 'completed' && !isReadOnly && (
                            <div className="col-12 md:col-7">
                                <div className="flex flex-column gap-2">
                                    <label className="fk-label">Resultado de la Visita</label>
                                    <div className="flex gap-2">
                                        <button
                                            type="button"
                                            onClick={() => onCompletionOutcomeChange('successful')}
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '0.4rem',
                                                padding: '0.5rem 0.75rem',
                                                borderRadius: '10px',
                                                border: completionOutcome === 'successful' ? '2px solid #16a34a' : '1.5px solid #e2e8f0',
                                                background: completionOutcome === 'successful' ? '#dcfce7' : '#fff',
                                                color: completionOutcome === 'successful' ? '#15803d' : '#475569',
                                                fontWeight: 600,
                                                fontSize: '0.8rem',
                                                cursor: 'pointer',
                                                transition: 'all 0.15s',
                                            }}
                                        >
                                            <i className="pi pi-check-circle" />
                                            Exitosa
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => onCompletionOutcomeChange('unsuccessful')}
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '0.4rem',
                                                padding: '0.5rem 0.75rem',
                                                borderRadius: '10px',
                                                border: completionOutcome === 'unsuccessful' ? '2px solid #dc2626' : '1.5px solid #e2e8f0',
                                                background: completionOutcome === 'unsuccessful' ? '#fef2f2' : '#fff',
                                                color: completionOutcome === 'unsuccessful' ? '#b91c1c' : '#475569',
                                                fontWeight: 600,
                                                fontSize: '0.8rem',
                                                cursor: 'pointer',
                                                transition: 'all 0.15s',
                                            }}
                                        >
                                            <i className="pi pi-times-circle" />
                                            No Exitosa
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>

            {/* Card: Tipos de visita — solo PM */}
            {isPM && (
                <div className="tk-table-card">
                    {cardHeader('Tipos de Visita')}
                    <div style={{ padding: '1rem' }}>
                        <div className="fk-field fk-field--fluid">
                            <label className="fk-label">Selecciona los tipos de visita a realizar</label>
                            <div className={`fk-input ${validationErrors?.selectedVisitTypes ? 'fk-input--invalid' : ''}`}>
                                <MultiSelect
                                    value={selectedVisitTypes}
                                    options={visitTypeOptions}
                                    onChange={handleVisitTypeChange}
                                    placeholder="Selecciona los tipos de visita"
                                    display="chip"
                                    disabled={isReadOnly || currentStatus === 'paused'}
                                    className="w-full"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Datos por tipo de visita — sin card wrapper, DataForType ya trae sus propias cards */}
            {selectedVisitTypes.length > 0 ? (
                <>
                    {selectedVisitTypes.length > 1 && (
                        <TabMenu
                            model={items}
                            activeIndex={activeTab}
                            onTabChange={(e) => setActiveTab(e.index)}
                        />
                    )}
                    {selectedVisitTypes.map((type, index) => {
                        if (index !== activeTab) return null;
                        return (
                            <DataForType
                                key={type}
                                showVisitsCount={isPM}
                                visitsCount={visitsData[type]?.visitsCount || 2}
                                setVisitsCount={(v) => updateVisitData(type, 'visitsCount', v)}
                                // tentativeDate commented out — MANUS coordina la fecha
                                // tentativeDate={visitsData[type]?.tentativeDate || null}
                                // setTentativeDate={(v) => updateVisitData(type, 'tentativeDate', v)}
                                fullName={visitsData[type]?.fullName || ''}
                                setFullName={(v) => updateVisitData(type, 'fullName', v)}
                                recipientName={visitsData[type]?.recipientName || ''}
                                setRecipientName={(v) => updateVisitData(type, 'recipientName', v)}
                                phoneNumber={visitsData[type]?.phoneNumber || ''}
                                setPhoneNumber={(v) => updateVisitData(type, 'phoneNumber', v)}
                                address={visitsData[type]?.address || ''}
                                setAddress={(v) => updateVisitData(type, 'address', v)}
                                postalCode={visitsData[type]?.postalCode || ''}
                                setPostalCode={(v) => updateVisitData(type, 'postalCode', v)}
                                municipality={visitsData[type]?.municipality || ''}
                                setMunicipality={(v) => updateVisitData(type, 'municipality', v)}
                                colonia={visitsData[type]?.colonia || ''}
                                setColonia={(v) => updateVisitData(type, 'colonia', v)}
                                coloniasOptions={visitsData[type]?.coloniasOptions || []}
                                isReadOnly={isReadOnly || currentStatus === 'paused'}
                                errors={validationErrors && validationErrors[type] ? validationErrors[type] : {}}
                            />
                        );
                    })}
                </>
            ) : (
                <p style={{ color: '#94a3b8', fontStyle: 'italic', fontSize: '0.85rem', margin: '0.5rem 0' }}>
                    No hay tipos de visita seleccionados.
                </p>
            )}

        </div>
    );
};
